<template>
  <div id="ongoing" ref="ongoing" style="position: relative">
    <div
      class="amap-wrapper"
      :style="{ height: heightAll - 30 + 'px', overflow: 'hidden' }"
      id="full"
      ref="full"
      v-loading="loading"
    >
      <div
        id="container"
        ref="container"
        style="position: relative;height: 100%;"
      ></div>
      <div id="panel"></div>
      <div
        id="myPageTop"
        style="position: absolute;top: 20px;right: 20px;background: transparent;"
      >
        <el-input
          id="tipinput"
          style="width: 240px"
          size="small"
          placeholder="请输入关键字(enter键搜索）"
          v-model="input"
          @keyup.enter.native="searchAddress"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="searchAddress"
          ></i>
        </el-input>
      </div>
      <div class="toggle">
        <el-button @click="toggleList" type="text" size="small" class="shadow">切换至列表模式</el-button>
      </div>
      <el-dialog
        id="dia"
        v-dialog-drag
        :close-on-click-modal="false"
        title="执法详情"
        top="5vh"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        width="50%"
      >
        <div>
          <!--有图片时显示的-->
          <el-row :gutter="20" v-if="detailMap.mainPhoto">
            <el-col :span="16">
              <div class="grid-content">
                <div>
                  <i class="icon"></i><span style="color: red;font-size: 13px">执法进行中</span>
                </div>
                <div>永川执法大队{{ detailMap.deptName }}</div>
                <div>正在对{{ detailMap.mchName }}进行执法检查</div>
                <blockquote
                  class="layui-elem-quote layui-quote-nm mt8"
                  style="padding: 6px 12px;"
                >
                  <p>组长：{{ detailMap.addUserName }}</p>
                  <p>
                    组员：
                    <span
                      v-for="(item, index) in detailMap.groupUserInfoVoList"
                      :key="index"
                      >{{ item.realName }}</span>
                  </p>
                </blockquote>
                <div>检查开始时间：{{ detailMap.time }}</div>
              </div></el-col>
            <el-col :span="8" v-show="detailMap">
              <div class="grid-content">
                <!--//图片待插入-->
                <img
                  src="../../../public/static/images/example.jpg"
                  class="object-fit-cover"
                  alt=""
                />
              </div>
            </el-col>
          </el-row>
          <!--无图片时显示的-->
          <el-row :gutter="20" v-else>
            <el-col :span="24">
              <div class="grid-content">
                <div style="line-height: 24px">
                  <i class="icon"></i><span style="color: red;font-size: 16px">执法进行中</span>
                </div>
                <div class="mapWrap">
                  <div style="font-size: 15px">
                    <strong>{{
                      detailMap.deptName ? detailMap.deptName : "(暂无信息)"
                    }}</strong>
                    正在对
                    <strong>{{
                      detailMap.mchName ? detailMap.mchName : "(暂无信息)"
                    }}</strong>进行执法检查
                  </div>
                  <blockquote
                    class="layui-elem-quote layui-quote-nm mt8"
                    style="padding: 6px 12px;"
                  >
                    <p style="margin-bottom: 3px">
                      <span class="group">组长</span>:
                      {{ detailMap.addUserName }}
                    </p>
                    <p>
                      <span class="group">组员</span>:
                      <span
                        v-for="(item, index) in detailMap.groupUserInfoVoList"
                        :key="index"
                        >{{ item.realName }}</span>
                    </p>
                  </blockquote>
                  <div>检查开始时间：{{ detailMap.time }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import AMap from "AMap";
import { getLatiyudeAndLongtitude, getMapDetail } from "@/api/module/task";
import { mapState,mapGetters} from 'vuex'

export default {
  name: "OngoingTask",
  watch: {
    $route(to, from) {
      // this.$router.go(0)
      if (
        to.query.longitude != from.query.longitude &&
        to.query.latitude != from.query.latitude
      ) {
        this.receivelongitude = to.query.longitude;
        this.receivelatitude = to.query.latitude;
        if (this.receivelongitude && this.receivelatitude) {
          this.reqMapInfo();
        }
      }
    }
  },

  props: ["heightAll"],
  data() {
    return {
      currentMenuId:this.$route.query.currentMenuId,
      dialogVisible: false,
      markerInfo: [],
      bell: "bell",
      loading: true,
      receivelongitude: this.$route.query.longitude,
      receivelatitude: this.$route.query.latitude,

      detailMap: {}, // 任务进行中的详细信息
      unresolvedNum: 0, // 未完成任务数
      input: "",
      placeSearch: {},
    };
  },
  methods: {
    // 请求接口获取经纬度
    reqMapInfo() {
      getLatiyudeAndLongtitude(
        null,
        res => {
          this.loading = false;
          // console.log(res);
          this.markerInfo = res.obj;
          this.init();
        },
        res => {
          // console.log(res);
        },
        this.currentMenuId
      );
    },

    init() {
      const _this = this;
      // 初始化地图对象，加载地图
      const map = new AMap.Map("container", {
        resizeEnable: true,
        center: [116.397428, 39.90923],
        zoom: 18,
        viewMode: "3D" // 使用3D视图
      });

      // 获取位置信息
      const markerInfoNow = [];
      let j = 0;
      for (let i = 0; i < _this.markerInfo.length; i += 1) {
        if (
          _this.markerInfo[i].latitude == null ||
          _this.markerInfo[i].longitude == null
        ) {
          j += 1; // 统计未完成任务数
          continue;
        } else {
          markerInfoNow.push(_this.markerInfo[i]);
        }
      }
      _this.unresolvedNum = j;
      AMap.service(["AMap.PlaceSearch", "AMap.Autocomplete"], () => {
        // 构造地点查询类
        _this.placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          citylimit: false, // 是否强制限制在设置的城市内搜索
          map, // 展现结果的地图实例
          showCover: false, // 是否在地图上显示周边搜索的圆或者范围搜索的多边形
          // panel: "panel", // 结果列表将在此容器中进行展示。
          autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
          renderStyle: "default"
        });
      });

      // 定义窗体信息
      const infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, -30)
      });

      for (let i = 0; i < markerInfoNow.length; i += 1) {
        const marker = new AMap.Marker({
          position: [markerInfoNow[i].longitude, markerInfoNow[i].latitude],
          icon: "../../static/images/loc.png",
          map
        });
        const depName = markerInfoNow[i].deptName
          ? markerInfoNow[i].deptName
          : "(暂无信息)";
        const mchName = markerInfoNow[i].mchName
          ? markerInfoNow[i].mchName
          : "(暂无信息)";
        marker.content = `${depName}正在对${mchName}进行检查`;
        marker.baseId = markerInfoNow[i].inspectBaseId;
        marker.on("click", markerClick);
        marker.on("mouseover", markerOver);
        marker.on("mouseout", markerOut);
      }
      if (markerInfoNow && markerInfoNow.length > 0) {
        map.setZoomAndCenter(13, [
          markerInfoNow[0].longitude,
          markerInfoNow[0].latitude
        ]); // 同时设置地图层级与中心点
      }

      _this.$message({
        message: `未确定检查位置的任务数：${_this.unresolvedNum}`,
        center: true,
        showClose: true,
        customClass: "bell"
      });

      function markerOver(e) {
        infoWindow.setContent(e.target.content);
        infoWindow.open(map, e.target.getPosition());
      }

      function markerOut(e) {
        infoWindow.close();
      }

      function markerClick(e) {
        const lats = e.target.getPosition().lat;
        const lngs = e.target.getPosition().lng;

        map.panTo([lngs, lats]);
        _this.dialogVisible = true;
        // console.log(e);
        let IDobJ = { inspectBaseId: e.target.baseId };
        getMapDetail(
          IDobJ,
          res => {
            // console.log(res);
            if (res.success) {
              _this.detailMap = res.obj;
              _this.detailMap.time = _this.renderTime(res.obj.beginTime);
            } else {
              _this.detailMap = {};
            }
          },
          res => {},
          _this.currentMenuId
        );
      }
      // 由列表跳转至地图时 要显示的具体位置
      if (_this.receivelongitude && _this.receivelatitude) {
        const position = new AMap.LngLat(
          _this.receivelongitude,
          _this.receivelatitude
        ); // 标准写法
        map.setCenter(position);
        map.setZoom(18);
      }
    },

    // 修改时间格式
    renderTime(date) {
      const dateee = new Date(date).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
    },
    // 搜索地址
    searchAddress() {
      this.placeSearch.search(this.input, () => {
        if (!this.input) {
          this.placeSearch.render.markerList.clear(); // 搜索成功后  清除查到的标记点(插件自带的地点标记点）
        }
      });
    },
    // 搜的是地点 ，暂时不用
    selectAddress(e) {
      // 这里获得点选地点的经纬度
      this.placeSearch.setCity(e.poi.adcode);
      this.placeSearch.search(e.poi.name); // 关键字查询查询
      // Do Something
    },
    toggleList() {
      this.$router.push({ path: "/laws/ongoingList" });
    }
  },
  mounted() {
    this.reqMapInfo();
  }
};
</script>

<style scoped>
@import "../../assets/dialog.css";
#ongoing {
  background: white;
  overflow: hidden;
  padding: 10px;
  position: relative;
}
.amap-wrapper {
  width: 100%;
  height: 500px;
}
#container {
  height: 500px;
}
.mapWrap {
  border: 1px solid #bbe1f1;
  border-radius: 4px;
  padding: 20px;
  margin: 10px 0 20px 0;
  /*height: 250px;*/
}

.icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #f21b1b;
  border-radius: 50%;
  margin-right: 10px;
  box-shadow: 8px 3px 3px 1px #6b2a44;
  animation: mymove 1s infinite;
  -webkit-animation: mymove 1s infinite; /* Safari 和 Chrome */
}

.group {
  font-size: 15px;
  color: black;
}

#ongoing >>> .el-message {
  background: orangered;
}

@keyframes mymove {
  0% {
    box-shadow: 1px 2px 3px 1px #6b2a44;
  }
  50% {
    box-shadow: 3px 2px 5px 3px #df2f39;
  }
  100% {
    box-shadow: 1px 2px 3px 1px #6b2a44;
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/ {
  0% {
    box-shadow: 1px 2px 3px 1px #6b2a44;
  }
  50% {
    box-shadow: 3px 2px 5px 3px #df2f39;
  }
  100% {
    box-shadow: 1px 2px 3px 1px #6b2a44;
  }
}

.el-dialog__body {
  padding: 10px 20px 30px;
}
#panel {
  position: absolute;
  background-color: white;
  max-height: 90%;
  overflow-y: auto;
  top: 80px;
  right: 10px;
  width: 280px;
}
.bell {
  background: #e94e4e;
}
.toggle {
  position: absolute;
  top: 15px;
  left: 20px;
  background: transparent;
  transition: all 1s;
}
.toggle:hover {
  background: white;
  top: 20px;

  border: 1px solid #b2e2fe;
  border-radius: 5px;
}

.shadow {
  background: rgba(255, 255, 255, 0.8);
  /*background: #123dda;*/
  background: #336699;
  padding: 8px 10px;
  /*color:#8eff40;*/
  color: #ffffff;
}
.amap-info-sharp {
  background-image: none;
  border: none;
  width: 0;
  height: 0;
  border-right: 50px solid transparent;
  border-left: 50px solid transparent;
  border-top: 50px solid red;
}
</style>
